"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconInvoiceRequest = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconInvoiceRequest = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: !!theme ? (theme.name !== 'privalia' ? theme.colors.main.base : theme.colors.red.s75) : '#EC008C', d: "M19.8364,12.8477 L16.5054,16.5547 C16.4234,16.6367 16.3114,16.6827 16.1954,16.6827 C16.1784,16.6827 16.1604,16.6817 16.1434,16.6797 C16.0094,16.6627 15.8904,16.5867 15.8204,16.4717 L15.0004,14.4827 C14.8754,14.2747 14.9414,14.0047 15.1494,13.8797 C15.3564,13.7547 15.6254,13.8217 15.7514,14.0287 L16.2814,15.1737 L19.2164,12.3007 C19.3874,12.1287 19.7384,12.0557 19.9094,12.2277 C20.0804,12.3987 20.0074,12.6757 19.8364,12.8477 M17.5004,9.9347 C15.0144,9.9347 13.0004,11.9497 13.0004,14.4347 C13.0004,16.9197 15.0144,18.9347 17.5004,18.9347 C19.9854,18.9347 22.0004,16.9197 22.0004,14.4347 C22.0004,11.9497 19.9854,9.9347 17.5004,9.9347" }),
            React.createElement("path", { fill: "#464650", d: "M14,3.3848 L14,5.9998 L16.958,5.9998 L14,3.3848 Z M17.5,8.9998 C17.224,8.9998 17,8.7768 17,8.4998 L17,6.9998 L13.5,6.9998 C13.224,6.9998 13,6.7768 13,6.4998 L13,2.9998 L3.497,2.9998 C3.223,2.9998 3,3.2178 3,3.4858 L3,20.5148 C3,20.7818 3.223,20.9998 3.497,20.9998 L16.5,20.9998 C16.724,20.9998 17,20.7248 17,20.4998 C17,20.2238 17.224,19.9998 17.5,19.9998 C17.776,19.9998 18,20.2238 18,20.4998 C18,21.2718 17.271,21.9998 16.5,21.9998 L3.497,21.9998 C2.671,21.9998 2,21.3338 2,20.5148 L2,3.4858 C2,2.6658 2.671,1.9998 3.497,1.9998 L13.755,1.9998 C13.877,1.9998 13.995,2.0448 14.086,2.1248 L17.831,5.4368 C17.938,5.5318 18,5.6678 18,5.8118 L18,8.4998 C18,8.7768 17.776,8.9998 17.5,8.9998 Z M4,9 L4,8 L7,8 L7,9 L4,9 Z M4,7 L4,6 L10,6 L10,7 L4,7 Z M3.921,13 L3.921,12 L12,12 L12,13 L3.921,13 Z M3.921,15 L3.921,14 L11,14 L11,15 L3.921,15 Z M3.921,17 L3.921,16 L12,16 L12,17 L3.921,17 Z M3.921,19 L3.921,18 L9.039,18 L9.039,19 L3.921,19 Z" }))));
};
exports.IconInvoiceRequest = IconInvoiceRequest;
exports.IconInvoiceRequest.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconInvoiceRequest;
